// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Config from "../../constants/Config";
import Modal from "../organisms/Modal";
import QuickSearch from "../molecules/QuickSearch";
import LinkHandler from "../atoms/LinkHandler";
import Icon from "../atoms/Icon";
type PropsType = {
    active?: boolean,
    focusSearch?: boolean,
    onClose?: Function,
};

const MobileMenuModal = (props: PropsType): React.Node => {
    const { primary_menu } = useSelector((state: any): any => state.options);
    const { loggedIn } = useSelector((state: any): any => state.user);
    const location = useLocation();
    const [activePrimaryDropdowns, setActivePrimaryDropdowns] = React.useState(
        {}
    );
    const [activeSearchResults, setActiveSearchResults] = React.useState(false);

    const primaryItemHoverIn = (index: number) => {
        setActivePrimaryDropdowns({
            ...activePrimaryDropdowns,
            [index]: !activePrimaryDropdowns[index],
        });
    };

    // Close all dropdowns when path changes
    React.useEffect((): Function => {
        setActivePrimaryDropdowns({});
    }, [location.pathname]);

    // Main menu nav items
    const renderPrimaryLinks = (): React.Node => {
        if (!primary_menu) return null;

        return primary_menu.map((menuItem: any, index: number): React.Node => {
            const hasDropdown =
                menuItem.drop_down_column && menuItem.drop_down_column.length;

            const activeDropdown = activePrimaryDropdowns[index];

            const openDropdown = e => {
                e.preventDefault();
                primaryItemHoverIn(index);
            };

            return (
                <li
                    className={`mobile-menu__item  ${
                        activeDropdown ? "is-active" : ""
                    }`}
                    key={index}
                >
                    <LinkHandler
                        to={menuItem.link.url}
                        target={menuItem.link.target}
                        className={`mobile-menu__item__link`}
                    >
                        <span
                            className="text"
                            dangerouslySetInnerHTML={{
                                __html: menuItem.link.title,
                            }}
                        />

                        {hasDropdown ? (
                            <span
                                className="mobile-menu__item__link__chevron"
                                onClick={openDropdown}
                            >
                                <Icon name="chevron-down" />
                            </span>
                        ) : null}
                    </LinkHandler>

                    {/* Dropdown */}
                    {hasDropdown ? (
                        <div
                            className={`mobile-menu__item__dropdown ${
                                activeDropdown ? "is-active" : ""
                            }`}
                        >
                            {menuItem.drop_down_column.map(
                                (
                                    dropDownColumn: any,
                                    index: number
                                ): React.Node => {
                                    return (
                                        <ul
                                            key={index}
                                            className="mobile-menu__item__dropdown__col"
                                        >
                                            {dropDownColumn.main_link ? (
                                                <li>
                                                    <LinkHandler
                                                        to={
                                                            dropDownColumn
                                                                .main_link.url
                                                        }
                                                        target={
                                                            dropDownColumn
                                                                .main_link
                                                                .target
                                                        }
                                                        className="mobile-menu__item__dropdown__link mobile-menu__item__dropdown__link--main"
                                                    >
                                                        {
                                                            dropDownColumn
                                                                .main_link.title
                                                        }
                                                    </LinkHandler>
                                                </li>
                                            ) : null}

                                            {dropDownColumn.sub_links
                                                ? dropDownColumn.sub_links.map(
                                                      (
                                                          subLink: any,
                                                          index: number
                                                      ): React.Node => {
                                                          return (
                                                              <li key={index}>
                                                                  <LinkHandler
                                                                      to={
                                                                          subLink
                                                                              .link
                                                                              .url
                                                                      }
                                                                      target={
                                                                          subLink
                                                                              .link
                                                                              .target
                                                                      }
                                                                      className="mobile-menu__item__dropdown__link"
                                                                  >
                                                                      {
                                                                          subLink
                                                                              .link
                                                                              .title
                                                                      }
                                                                  </LinkHandler>
                                                              </li>
                                                          );
                                                      }
                                                  )
                                                : null}
                                        </ul>
                                    );
                                }
                            )}
                        </div>
                    ) : null}
                </li>
            );
        });
    };

    return (
        <>
            <Modal
                aside={true}
                active={props.active}
                onClose={() => {
                    if (props.onClose) {
                        props.onClose();
                    }
                }}
            >
                <Modal.Header clear={true}></Modal.Header>
                <Modal.Content>
                    <div className="container-fluid">
                        <QuickSearch
                            focusOnMount={props.focusSearch}
                            onResults={() => setActiveSearchResults(true)}
                            onClear={() => setActiveSearchResults(false)}
                        />

                        {!activeSearchResults ? (
                            <>
                                <ul className="mobile-menu">
                                    {renderPrimaryLinks()}
                                </ul>

                                <ul className="mobile-menu mobile-menu--functions">
                                    <li>
                                        {loggedIn ? (
                                            <LinkHandler
                                                to={Config.routes.editProfile}
                                                className={`mobile-menu__item__link`}
                                            >
                                                <Icon name="user" />
                                                <span className="text">
                                                    My Account
                                                </span>
                                            </LinkHandler>
                                        ) : (
                                            <LinkHandler
                                                to={Config.routes.login}
                                                className={`mobile-menu__item__link`}
                                            >
                                                <Icon name="user" />
                                                <span className="text">
                                                    Login{" "}
                                                    <span className="slash">
                                                        /
                                                    </span>{" "}
                                                    Sign up
                                                </span>
                                            </LinkHandler>
                                        )}
                                    </li>
                                    <li>
                                        <LinkHandler
                                            to={Config.routes.cart}
                                            className={`mobile-menu__item__link`}
                                        >
                                            <Icon name="cart" />
                                            <span className="text">Cart</span>
                                        </LinkHandler>
                                    </li>
                                </ul>
                            </>
                        ) : null}
                    </div>
                </Modal.Content>
            </Modal>
        </>
    );
};

export default MobileMenuModal;
